import { createContext, useContext, useState } from 'react';

/**
 * TestPlansContext — the orchestration results handoff, split out of
 * GlobalProvider on 22 Aug 2026 (the shape was designed in
 * .kiro/specs/test-plans-global-context-migration).
 *
 * One value, deliberately: the test-plans list and the results page stash
 * fetched executions here and OrchestrationReport renders them. The split
 * originally carried three more pairs (selectedRow, currentOrchestration,
 * orchestrationLoader) that had writers but no readers — a loading flag
 * shadowing the real local one, and a selection nothing consulted. They were
 * deleted once confirmed dead, along with the callbacks that fed them.
 *
 * Mounted app-level because the list -> report flow crosses routes, but
 * feature-owned: only test-plans code should import this.
 */
export const TestPlansContext = createContext(undefined);

export const TestPlansProvider = ({ children }) => {
  const [responseData, setResponseData] = useState(null);

  return (
    <TestPlansContext.Provider value={{ responseData, setResponseData }}>
      {children}
    </TestPlansContext.Provider>
  );
};

/** Consumers destructure exactly as they did from GlobalContext. */
export const useTestPlansContext = () => useContext(TestPlansContext) || {};

export default TestPlansProvider;
